export default __webpack_public_path__ + "static/media/cover.6232b7f4.jpg";